import React from "react";
import cns from "classnames";
import { Close } from "@material-ui/icons";
import locale from "@bonliva-crm/locale";
import { RegularButton } from "@components";
import { makeStyles } from "@material-ui/core/styles";
import { ThemeType } from "@theme";

export type ClearSearchProps = {
  className?: string;
  style?: React.CSSProperties;
  onClick: () => void;
};

export function ClearSearch(props: ClearSearchProps) {
  const classes = useStyles({});

  return (
    <div className={cns(classes.clearSearchWrapper, props.className)} style={props.style}>
      <div className={classes.clearSearch}>
        <RegularButton
          leftIcon={<Close />}
          size="small"
          variant="text"
          onClick={props.onClick}
        >
          {locale.Clear}
        </RegularButton>
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  clearSearchWrapper: {
    ...theme.fixedGrid,
    position: "absolute",
    right: 0,
    left: 0,
    display: "flex",
    justifyContent: "flex-end"
  },

  clearSearch: {
    padding: 16,
    paddingBottom: 0,
    zIndex: 1001
  }
}));
